import { makeAutoObservable } from "mobx";
import {
  ZCatalog,
  ZCatalogClassifierItem,
} from "src/business/catalog/ZCatalog";
import { RtStore } from "src/components/ReactiveTable/RtStore";

import { CatalogCardValues, FnCatalogSave } from "./CatalogCardValues";
import {
  createLocalClassifierLoader,
  LocalClassifierLoader,
  LocalClassifiersFilter,
} from "./LocalClassifierLoader";

export class CatalogCardStore {
  constructor() {
    this.clsLoader = createLocalClassifierLoader();

    this.clsStore = new RtStore({
      rowKey: "id",
      loader: this.clsLoader,
    });
    makeAutoObservable(this);
  }

  tab: string = "1";

  setTab(newTab: string) {
    this.tab = newTab;
  }

  clsStore: RtStore<ZCatalogClassifierItem, LocalClassifiersFilter>;

  clsLoader: LocalClassifierLoader;

  onClsChange(newData: ZCatalogClassifierItem[]) {
    this.clsLoader.setData(newData);
    this.clsStore.onDataChanged();
  }

  saving = false;

  setSaving(value: boolean) {
    this.saving = value;
  }

  async onSubmit(
    values: CatalogCardValues,
    submit: FnCatalogSave,
  ): Promise<ZCatalog> {
    try {
      this.setSaving(true);
      return await submit(values);
    } finally {
      this.setSaving(false);
    }
  }

  expired = false;

  setExpired(value: boolean) {
    this.expired = value;
  }
}
